import React from 'react'
import Dialog  from '../dialog/Dialog';
import { Sidebar, HeightSidebar } from '../Sidebar';
import QRCode from "react-qr-code";
import Barcode from '../Barcode';
import { Coupon } from '../../models/coupon';

//AVCDAAV.002  21/03/2025  Add code for  Adding RedeemCode page

type Props = {
    onHide: () => void;
    show: boolean;
    couponDesc?: string;
    type: "dialog" | "sidebar"
    code?: string;
}

export const RedeemCode = (props: Props) => {
    if (!props.code) return null;

    const heightSidebar: HeightSidebar  = "large"
    return (
        <>
            {props.type === "dialog" && (
                <Dialog show={props.show} handleClose={props.onHide} centered width='medium' height='70vh'
                    closeIconInner
                >
                    <div className='redeem-code-box'>
                        <div className='redeem-code-header'>สแกนเพื่อรับสิทธิ์</div>
                        <div className='redeem-code-header'>{props.couponDesc}</div>
                        <div className='redeem-code-body custom-body'>
                            <Barcode value={props.code} barcodeProperties={{height: 85, textPosition: "bottom", fontSize: 18, marginTop: 15}}/>
                            <QRCode value={props.code} size={200}/>
                        </div>
                    </div>
                </Dialog>
            )}
            {props.type === "sidebar" && (
                <Sidebar show={props.show} onHide={props.onHide} position="bottom"
                    height={heightSidebar}
                    radius='top'
                >
                    <div className='redeem-code-box'>
                        <div className={`redeem-code-header ${heightSidebar}`}>สแกนเพื่อรับสิทธิ์</div>
                        <div className={`redeem-code-header ${heightSidebar}`}>{props.couponDesc}</div>
                        <div className='redeem-code-body'>
                            <Barcode value={props.code} barcodeProperties={{height: 85, textPosition: "bottom", fontSize: 18, marginTop: 15}}/>
                            <QRCode value={props.code} size={200}/>
                        </div>
                    </div>
                </Sidebar>
            )}
        </>
    )
}

//C-AVCDAAV.002  21/03/2025  Add code for  Adding RedeemCode page
